export default __webpack_public_path__ + "static/media/type-gradient.07cb759f.png";